<template lang="pug">
content-page
	div(slot="nav")
		navigation-default
	.flow-left
		h1 {{contentpage.name}}
		ws-content(:value="contentpage.content")
			person-grid-list(:persons="members")

</template>

<script>
import gql from 'graphql-tag';
import Content from '@dengl/common/components/content.vue';
import PersonGridList from '@/components/person-grid-list.vue';
import MetaFragment from '@/components/graphql/metaFragment.graphql';
import NavigationDefault from '@/components/navigation-default';

const query = gql`
	query getTeamMembers($slug: String!) {
		team {
			id
			user {
				slug
			}
			name
			function
			photo
		}

		contentpage(slug: $slug) {
			id
			name
			slug
			content {
				...ContentDataFragment
			}
			...MetaFragment
		}
	}
	${MetaFragment}
	${Content.fragments}
`;

export default {
	nuxtI18n: {
		paths: {
			'nl-NL': '/over-ons',
			'de-DE': '/team',
			'nl-BE': '/over-ons'
		}
	},
	components: { PersonGridList, Content, NavigationDefault },
	asyncData({ _params, app }) {
		app.ads({ sidebar: { visible: true } });
		return app.$graphClient
			.query({
				query,
				variables: {
					slug: 'over-ons'
				},
				errorPolicy: 'all'
			})
			.then(({ data, errors }) => {
				if (errors) {
					throw errors[0];
				}

				app.meta(data.contentpage.meta);
				app.breadcrumbs({
					'Over ons': { name: 'over-ons' }
				});

				return data;
			})
			.catch(error => {
				return app.httpError(500, null, 'over-ons-01', error);
			});
	},
	head() {
		return {
			...this.$structuredData()
		};
	},
	computed: {
		members() {
			return this.team.map(member => {
				member.image = member.photo
					? member.photo
					: 'https://static.wintersport.nl/images/avatar-w48.png';
				member.to = member.user
					? this.localePath({
							name: 'profile-slug',
							params: { slug: member.user.slug }
					  })
					: null;
				member.sub = member.function;
				return member;
			});
		}
	}
};
</script>
